export default __webpack_public_path__ + "static/media/huyetnhan.a5f65124.png";